import { useMutation } from '@tanstack/react-query';
import { resendInviteOtp } from '@/api/invites.api';

/**
 * Resend-invite-OTP mutation (US-038/US-098). Mirrors `useResendOtp`: the
 * backend is deliberately non-enumerating, so success here only means
 * "request accepted" - the UI shows a neutral confirmation either way.
 */
export function useResendInviteOtp(token: string) {
  return useMutation({ mutationFn: () => resendInviteOtp(token) });
}
